import { Command } from "../../../../react-mvvm/src";

export class ArticleLoginSectionViewModel {
  readonly type = "LOGIN";

  constructor(public handleLogin: Command) {}
}
